module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/bfefb3d914bc2dc01a2910d70fb8b708.png";